import { toast } from "react-toastify";

export const errorHandler = (error) => {
  if (error.message === "Network Error" && error.status === 500) {
    toast.error(error.message);
  }
  toast.error(error?.response?.data?.message);
};
